<template>
    <!--
      Shared sub-navigation for the two graph curation surfaces. The sidebar only
      renders two levels, so the grouping lives here as a tab strip that both
      pages render directly under their header.
    -->
    <div class="curation-tabs">
        <router-link
            v-for="tab in tabs"
            :key="tab.name"
            :to="{ name: tab.name, params: { cid } }"
            class="curation-tab"
            :class="{ active: $route.name === tab.name }"
        >
            <i :class="tab.icon"></i>
            <span>{{ tab.label }}</span>
            <small v-if="tab.hint" class="curation-tab-hint">{{ tab.hint }}</small>
        </router-link>
    </div>
</template>

<script>
export default {
    name: 'CurationTabs',
    data() {
        return {
            tabs: [
                {
                    label: 'Recommendations',
                    hint: 'merge / split',
                    icon: 'fa fa-code-branch',
                    name: 'Graph Curation',
                },
                {
                    label: 'Cluster Formation',
                    hint: 'how a cluster formed',
                    icon: 'fa fa-diagram-project',
                    name: 'Cluster Formation',
                },
            ],
        }
    },
    computed: {
        /* The selected client wins over the URL: if the two ever disagree, a tab
           must not carry the stale cid along and switch the client back. */
        cid() {
            return this.$store.state.currentClient?.cid || this.$route.params.cid || ''
        },
    },
}
</script>

<style scoped>
.curation-tabs {
    display: flex;
    gap: 4px;
    padding: 0 0 0 2px;
    border-bottom: 1px solid #e6eaf0;
    margin-bottom: 14px;
}
.curation-tab {
    display: inline-flex;
    align-items: baseline;
    gap: 7px;
    padding: 9px 16px;
    font-size: 13px;
    font-weight: 600;
    color: #7c8798;
    text-decoration: none;
    border-bottom: 2px solid transparent;
    margin-bottom: -1px;
    transition: color 0.14s, border-color 0.14s;
    white-space: nowrap;
}
.curation-tab i {
    font-size: 11px;
    opacity: 0.75;
}
.curation-tab:hover {
    color: #0f172a;
}
.curation-tab.active {
    color: #0f766e;
    border-bottom-color: #0f766e;
}
.curation-tab-hint {
    font-size: 10px;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 0.07em;
    opacity: 0.6;
}
@media (max-width: 575.98px) {
    .curation-tab-hint {
        display: none;
    }
}
</style>

<style lang="scss">
@use '../theme/scss/_user-variables.scss' as *;

body.dark-mode {
    .curation-tabs { border-bottom-color: $dark-border-color; }
    .curation-tab { color: $dark-text-muted; }
    .curation-tab:hover { color: $dark-text-primary; }
    .curation-tab.active { color: #2dd4bf; border-bottom-color: #2dd4bf; }
}
</style>
